<template>
  <!-- Begin Page Content -->
  <div>
    <div
      class="card shadow-sm border-0 my-4"
      v-if="permissions.includes('snapshot.report')"
    >
      <div class="card-body">
        <!-- Header -->
        <!-- <div class="px-2 pt-2 d-flex justify-content-between align-items-center">
                    <h4 class="font-bold-m-0 text-primary">Snapshot By Year</h4>
                </div> -->
        <!-- Filters -->
        <div class="mb-3 row">
          <div class="col-lg-2 col-12">
            <h4
              class="font-bold-m-0 text-md-start text-center text-primary px-2 pt-2"
            >
              Productivity Report
            </h4>
          </div>
          <div
            class="col-lg-10 col-12 d-flex mt-md-0 mt-4 flex-md-row flex-column justify-content-end align-items-center gap-2"
          >
            <multiselect
              v-if="page != 'for_tls_team'"
              :options="user_list"
              v-model="reqObj.users"
              :disabled="disabled"
              track-by="id"
              label="full_name"
              :multiple="true"
              group-label="label"
              group-values="users_data"
              :group-select="true"
              :close-on-select="false"
              :custom-label="custom_label"
              placeholder="Select the user(s)"
            >
            </multiselect>
            <multiselect
              v-if="page != 'for_tls_team'"
              :options="project_type_list"
              v-model="reqObj.project_type"
              track-by="id"
              label="label"
              :disabled="disabled"
              placeholder="Select the project type"
            >
            </multiselect>
            <multiselect
              v-if="page != 'for_tls_team'"
              :options="client_list"
              v-model="reqObj.clients"
              track-by="id"
              label="name"
              :multiple="true"
              group-label="label"
              group-values="clients_data"
              :group-select="true"
              :close-on-select="false"
              :disabled="disabled"
              placeholder="Select the client(s)"
            >
            </multiselect>
            <multiselect
              v-if="page != 'for_tls_team'"
              :options="organization_list"
              v-model="reqObj.organizations"
              track-by="id"
              label="name"
              :multiple="true"
              group-label="label"
              group-values="user_organization"
              :group-select="true"
              :close-on-select="false"
              :disabled="disabled"
              placeholder="Select the organization(s)"
            >
            </multiselect>
            <div
              class="form-check form-switch form-check-reverse"
              v-if="page == 'for_tls_team'"
            >
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                v-model="hierarch_view"
                :disabled="disabled"
                @change="handleSwitchChange"
                id="flexSwitchCheckDefault"
              />
              <label class="form-check-label" for="flexSwitchCheckDefault"
                >With Hierarchy View</label
              >
            </div>
            <multiselect
              :class="[page != 'for_tls_team' ? '' : 'w-auto']"
              :options="date_range_list"
              v-model="reqObj.selected_range"
              @select="getFilteredUsers"
              :disabled="disabled"
              placeholder="Select the date range"
              track-by="label"
              label="label"
            >
            </multiselect>

            <button
              class="btn btn-primary"
              :disabled="disabled"
              @click="applyFilters"
            >
              Filter
            </button>
          </div>
        </div>
        <!-- Table body -->
        <div class="">
          <div class="">
            <div
              class="d-flex flex-column flex-md-row gap-3 justify-content-end align-items-center mb-2 px-2"
            >
              <div class="me-md-auto mx-md-0 mx-auto">
                <div class="nav nav-underline">
                  <span
                    disabled
                    class="nav-item"
                    @click="
                      disabled ? () => {} : optionChanger('for_all_users')
                    "
                  >
                    <span
                      class="nav-link pb-1"
                      :class="page == 'for_all_users' ? 'active' : ''"
                      >For all users</span
                    >
                  </span>
                  <span
                    class="nav-item"
                    @click="disabled ? () => {} : optionChanger('for_tls')"
                  >
                    <span
                      class="nav-link pb-1"
                      :class="page == 'for_tls' ? 'active' : ''"
                      >For TL's</span
                    >
                  </span>
                  <span
                    class="nav-item"
                    @click="disabled ? () => {} : optionChanger('for_tls_team')"
                  >
                    <span
                      class="nav-link pb-1"
                      :class="page == 'for_tls_team' ? 'active' : ''"
                      >For TL's Team</span
                    >
                  </span>
                </div>
              </div>
              <div class="text-end mb-md-2" v-if="rows">
                <a
                  class="link link-underline cursor-pointer link-underline-opacity-0 link-underline-opacity-100-hover"
                  @click="exportReport"
                  v-if="exported"
                  >Export</a
                >
                <div
                  v-else
                  class="spinner spinner-border text-primary"
                  style="height: 20px; width: 20px"
                ></div>
              </div>
              <div class="text-end mb-2" v-if="rows">
                Count : {{ rows.length }}
              </div>
            </div>
            <!-- FOR ALL USERS -->
            <!-- <div class="" v-if="page == 'for_all_users'"> -->
            <!-- <transition name="slide-fade" mode="out-in"> -->
            <div v-if="rows === null">
              <div class="p-5 text-center">
                <div
                  class="spinner spinner-border text-primary"
                  style="height: 4rem; width: 4rem"
                  key="loading"
                ></div>
              </div>
            </div>
            <div
              class="overflow-auto"
              style="height: 750px"
              v-else-if="
                rows &&
                rows.length &&
                ['for_tls', 'for_all_users'].includes(page)
              "
              :key="page"
            >
              <table class="table table-striped text-center text-danger">
                <thead class="table-light">
                  <tr class="">
                    <th
                      class="col-1 px-5 text-dark-emphasis position-sticky top-0 z-1"
                    >
                      <div class="d-flex align-items-center">
                        <div class="flex-grow-1">Username</div>
                        <!-- <div class="d-flex flex-column justify-content-center align-items-center">
                                                <i class="fa fa-caret-up fs-6"></i>
                                                <i class="fa fa-caret-down"></i>
                                            </div> -->
                      </div>
                    </th>
                    <th
                      class="col-1 text-dark-emphasis position-sticky top-0 z-1"
                    >
                      <div class="d-flex align-items-center">
                        <div class="flex-grow-1">Client</div>
                        <!-- <div class="d-flex flex-column justify-content-center align-items-center">
                                                <i class="fa fa-caret-up"></i>
                                                <i class="fa fa-caret-down"></i>
                                            </div> -->
                      </div>
                    </th>
                    <th
                      class="col-1 text-dark-emphasis position-sticky top-0 z-1"
                    >
                      B/NB
                    </th>
                    <th
                      class="col-1 text-dark-emphasis position-sticky top-0 z-1"
                    >
                      Total
                    </th>
                    <th
                      class="position-sticky top-0 z-1"
                      v-for="(item, index) in months"
                      :key="index"
                    >
                      <span class="text-dark-emphasis"
                        >{{ item.month_year_str }} |
                      </span>
                      <span class="text-secondary">{{
                        item.working_days
                      }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="">
                  <tr
                    v-for="(item, index) in rows"
                    :keys="index"
                    class="align-middle"
                  >
                    <td class="text-dark-emphasis">{{ item.full_name }}</td>
                    <td class="text-dark-emphasis">{{ item.client_name }}</td>
                    <td class="text-dark-emphasis">
                      {{ item.project_type }}
                    </td>
                    <td class="text-dark-emphasis">
                      {{ item.grand_total_time }}
                    </td>
                    <td
                      class="text-dark-emphasis"
                      v-for="(i, idx) in item.summary"
                      :key="idx"
                    >
                      {{ i.total_time }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else-if="rows && rows.length && page == 'for_tls_team'">
              <!-- <table class="table table-bordered">
                <thead class="table-light text-center">
                  <tr>
                    <th style="width: 20rem">User</th>
                    <th>Clients</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="loop in 10" :key="loop">
                    <td colspan="2" class="p-0">
                      <table class="table table-condensed m-0">
                        <tr>
                          <td
                            class="text-center align-middle"
                            style="width: 20rem; height: 40px"
                            rowspan="4"
                          >
                            <span> Test User {{ loop }} </span>
                          </td>
                          <td
                            role="button"
                            data-bs-toggle="collapse"
                            :data-bs-target="`#overview${loop}`"
                            style="height: 50px"
                            class="border-bottom"
                          >
                            <i class="fa fa-chevron-right fa-1"></i>
                            Overview
                          </td>
                        </tr>
                        <tr>
                          <td class="p-0 w-full">
                            <div
                              :id="`overview${loop}`"
                              class="container p-0 m-0 overflow-auto w-full collapse"
                              style="height: 300px"
                            >
                              <table
                                class="table table-condensed table-striped table-borderless m-0"
                              >
                                <thead
                                  class="table-light text-center position-sticky top-0"
                                >
                                  <tr>
                                    <th
                                      v-for="i in 10"
                                      :key="i"
                                      class="text-nowrap"
                                    >
                                      Client {{ i }}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody class="text-center">
                                  <tr v-for="i in 10" :key="i">
                                    <td
                                      v-for="j in 10"
                                      :key="j"
                                      class="text-nowrap"
                                    >
                                      Body {{ j }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            role="button"
                            data-bs-toggle="collapse"
                            :data-bs-target="`#detailsView${loop}`"
                            style="height: 50px"
                          >
                            <i class="fa fa-chevron-right fa-1"></i>
                            Details
                          </td>
                        </tr>
                        <tr>
                          <td class="p-0 w-full">
                            <div
                              :id="`detailsView${loop}`"
                              class="container p-0 m-0 overflow-auto w-full collapse"
                              style="height: 300px"
                            >
                              <table
                                class="table table-condensed table-striped table-borderless m-0"
                              >
                                <thead
                                  class="table-light text-center position-sticky top-0"
                                >
                                  <tr>
                                    <th
                                      v-for="i in 10"
                                      :key="i"
                                      class="text-nowrap"
                                    >
                                      Client {{ i }}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody class="text-center">
                                  <tr v-for="i in 10" :key="i">
                                    <td
                                      v-for="j in 10"
                                      :key="j"
                                      class="text-nowrap"
                                    >
                                      Body {{ j }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table> -->
              <div class="accordion" id="accordionParent">
                <div
                  class="accordion-item"
                  v-for="(tl_user, index) in rows"
                  :key="`accordion-item-${index + 1}`"
                >
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button bg-white text-dark px-3 py-2 collapsed"
                      data-bs-toggle="collapse"
                      :data-bs-target="`#accordion-${index + 1}`"
                    >
                      {{ tl_user.first_name.trim() }}
                      {{ tl_user.last_name.trim() }}
                    </button>
                  </h2>
                  <div
                    class="accordion-collapse collapse pb-4"
                    :id="`accordion-${index + 1}`"
                  >
                    <div class="accordion-body pt-0">
                      <ul
                        class="nav nav-underline"
                        role="tablist"
                        v-if="Object.hasOwn(tl_user, 'reporting_users')"
                      >
                        <li class="nav-item" role="presentation">
                          <span
                            class="nav-link active"
                            data-bs-toggle="tab"
                            :data-bs-target="`#overview-tab-${index + 1}`"
                            role="tab"
                            >Overview</span
                          >
                        </li>
                        <li class="nav-item" role="presentation">
                          <span
                            class="nav-link"
                            data-bs-toggle="tab"
                            :data-bs-target="`#details-tab-${index + 1}`"
                            role="tab"
                            >Details({{ tl_user.reporting_users.length }})</span
                          >
                        </li>
                      </ul>
                      <div class="tab-content">
                        <div
                          class="tab-pane show active"
                          :id="`overview-tab-${index + 1}`"
                        >
                          <div>
                            <div class="table-responsive">
                              <table
                                class="table table-striped table-borderless table-sm m-0"
                              >
                                <thead class="text-center">
                                  <tr>
                                    <th style="width: 100px">Month</th>
                                    <th
                                      style="white-space: nowrap"
                                      v-for="client in tl_user.overview[0]
                                        .summary"
                                    >
                                      {{ client.client_name }}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody class="text-center">
                                  <tr
                                    v-for="data in tl_user.overview"
                                    :key="data.month"
                                  >
                                    <td style="white-space: nowrap">
                                      {{ data.month }}
                                    </td>
                                    <td
                                      v-for="reportData in data.summary"
                                      :key="reportData.month"
                                    >
                                      {{ reportData.total_approved_hours }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="fw-bold">Total</td>
                                    <td
                                      class="fw-bold"
                                      v-for="data in tl_user.overview_total"
                                      :key="data.client_id"
                                    >
                                      {{ data.total }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane" :id="`details-tab-${index + 1}`">
                          <div class="accordion">
                            <div
                              class="accordion-item"
                              v-for="(user, index) in tl_user.reporting_users"
                              :key="`sub-accordion-item-${user.user_id}`"
                            >
                              <h2 class="accordion-header">
                                <button
                                  data-bs-toggle="collapse"
                                  :data-bs-target="`#sub-accordion-${user.user_id}`"
                                  class="accordion-button collapsed bg-light text-dark px-3 py-2"
                                >
                                  {{ user.first_name.trim() }}
                                  {{ user.last_name.trim() }}
                                </button>
                              </h2>
                              <div
                                class="accordion-collapse collapse"
                                :id="`sub-accordion-${user.user_id}`"
                              >
                                <div class="accordion-body pt-0">
                                  <div class="table-responsive">
                                    <table
                                      class="table table-striped table-borderless table-sm m-0"
                                    >
                                      <thead class="text-center">
                                        <tr>
                                          <th style="width: 100px">Month</th>
                                          <th
                                            style="white-space: nowrap"
                                            :key="client.client_name"
                                            v-for="client in user.data[0]
                                              .summary"
                                          >
                                            {{ client.client_name }}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody class="text-center">
                                        <tr
                                          v-for="data in user.data"
                                          :key="data.month"
                                        >
                                          <td style="white-space: nowrap">
                                            {{ data.month }}
                                          </td>
                                          <td
                                            v-for="reportData in data.summary"
                                            :key="reportData.month"
                                          >
                                            {{
                                              reportData.total_approved_hours
                                            }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="fw-bold">Total</td>
                                          <td
                                            class="fw-bold"
                                            v-for="data in user.data_total"
                                            :key="data.client_id"
                                          >
                                            {{ data.total }}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-5" v-else-if="error">
              <h4 class="text-center fw-normal">Failed to fetch report</h4>
            </div>
            <div class="p-5" v-else>
              <h4 class="text-center fw-normal">No data available</h4>
            </div>
            <!-- </transition> -->
            <!-- <div class="" v-if="page == 'for_tls'">
              <h1 class="p-5">tl report</h1>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <UnauthorizedPage></UnauthorizedPage>
    </div>
  </div>
</template>

<script>
import UnauthorizedPage from "./UnauthorizedPage.vue";
import user from "@/ajax/user";
import moment from "moment";
import { Multiselect } from "vue-multiselect";
export default {
  components: {
    UnauthorizedPage,
  },
  data() {
    return {
      exported: true,
      rows: null,
      months: [],
      disabled: false,
      error: false,
      master_user_list: [],
      user_list: [],
      client_list: [],
      organization_list: [],
      page: null,
      siteLogReq: {
        site_name: "productivity_report",
      },
      project_type_list: [
        {
          id: 1,
          label: "Billable ( B )",
          value: "B",
        },
        {
          id: 2,
          label: "Non Billable ( NB )",
          value: "NB",
        },
        {
          id: 3,
          label: "Both ( B/NB )",
          value: "Both",
        },
      ],
      sort_fields: [],
      date_range_list: [
        {
          label: "1st Apr22 to 31st Mar23",
          value: ["2022-04-01", "2023-03-31"],
        },
        {
          label: "1st Apr23 to 31st Mar24",
          value: ["2023-04-01", "2024-03-31"],
        },
        {
          label: "1st Apr24 to 31st Mar25",
          value: ["2024-04-01", "2025-03-31"],
        },
        {
          label: "1st Apr25 to 31st Mar26",
          value: ["2025-04-01", "2026-03-31"],
        },
      ],
      reqObj: {
        users: [],
        clients: [],
        organizations: [],
        selected_range: [],
        project_type: null,
      },
      hierarch_view: true,
      for_tl_team_data: [],
    };
  },
  methods: {
    handleSwitchChange(e) {
      this.hierarch_view = e.target.checked;
    },
    optionChanger(page) {
      if (this.page != page) {
        this.page = page;
        this.reqObj.users = [];
        this.reqObj.clients = [];
        this.reqObj.organizations = [];
        // this.handleDefaultDateRangeSelection();
        // this.reqObj.selected_range = this.date_range_list[1];
        this.reqObj.project_type = this.project_type_list[2];
        this.applyFilters();
      }
      // if (this.page == "for_tls_team") {
      //   this.getTlTeamProductivityReport();
      // }
    },
    exportReport() {
      let reqObjCopy = structuredClone(this.reqObj);
      reqObjCopy.organizations = reqObjCopy.organizations.map(
        (item) => item.id
      );
      reqObjCopy.users = reqObjCopy.users.map((item) => item.id);
      reqObjCopy.selected_range = reqObjCopy.selected_range.value;
      reqObjCopy.clients = reqObjCopy.clients.map((item) => item.id);
      reqObjCopy.project_type = reqObjCopy.project_type?.value;
      let startYear = moment(reqObjCopy.selected_range[0]).format("YY");
      let endYear = moment(reqObjCopy.selected_range[1]).format("YY");
      this.exported = false;
      if (this.page == "for_all_users") {
        user
          .exportProductivityReport(reqObjCopy)
          .then((res) => {
            let blob = res.data;
            // console.log(blob);

            let url = window.URL.createObjectURL(new Blob([blob]));
            let link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `Productivity_Report_${startYear}-${endYear}.xlsx`
            );
            link.click();

            window.URL.revokeObjectURL(url);
            this.exported = true;
          })
          .catch((err) => {
            Swal.fire({
              title: "Failed to export report",
              color: "white",
              toast: true,
              icon: "error",
              iconColor: "white",
              position: "top-end",
              background: "rgb(220, 20, 60)",
              timer: 1000,
              timerProgressBar: true,
              showConfirmButton: false,
              width: "30rem",
            });
            this.exported = true;
          });
      } else if (this.page == "for_tls") {
        user
          .exportApprovedHoursReport(reqObjCopy)
          .then((res) => {
            let blob = res.data;
            // console.log(blob);

            let url = window.URL.createObjectURL(new Blob([blob]));
            let link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `Approved_Hours_Report_${startYear}-${endYear}.xlsx`
            );
            link.click();

            window.URL.revokeObjectURL(url);
            this.exported = true;
          })
          .catch((err) => {
            Swal.fire({
              title: "Failed to export report",
              color: "white",
              toast: true,
              icon: "error",
              iconColor: "white",
              position: "top-end",
              background: "rgb(220, 20, 60)",
              timer: 1000,
              timerProgressBar: true,
              showConfirmButton: false,
              width: "30rem",
            });
            this.exported = true;
          });
      } else {
        const selected_range = reqObjCopy.selected_range;
        const hierarchy_view = this.hierarch_view;
        let export_file_name = `Productivity_Tl_Team_Report_${startYear}-${endYear}.xlsx`;
        if (!hierarchy_view) {
          export_file_name = `Productivity_User_Report_${startYear}-${endYear}.xlsx`;
        }
        user
          .exportTlTeamsProductivityReport({ selected_range, hierarchy_view })
          .then((res) => {
            let blob = res.data;
            // console.log(blob);

            let url = window.URL.createObjectURL(new Blob([blob]));
            let link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", export_file_name);
            link.click();

            window.URL.revokeObjectURL(url);
            this.exported = true;
          })
          .catch((err) => {
            Swal.fire({
              title: "Failed to export report",
              color: "white",
              toast: true,
              icon: "error",
              iconColor: "white",
              position: "top-end",
              background: "rgb(220, 20, 60)",
              timer: 1000,
              timerProgressBar: true,
              showConfirmButton: false,
              width: "30rem",
            });
            this.exported = true;
          });
      }
    },
    custom_label(name) {
      // console.log(name.first_name,name.middle_name,name.last_name);
      if (name.last_name != null && name.middle_name != null) {
        return `${name.first_name} ${name.middle_name} ${name.last_name}`;
      } else if (name.last_name == null) {
        return `${name.first_name} ${name.middle_name}`;
      } else if (name.middle_name == null) {
        return `${name.first_name} ${name.last_name}`;
      }
    },
    getTlTeamProductivityReport(reqObj) {
      this.rows = null;
      this.error = false;
      this.disabled = true;
      user
        .getTlTeamProductivityReport(reqObj)
        .then((res) => {
          // this.for_tl_team_data = res.data.data;
          this.rows = res.data.data;
          this.disabled = false;
        })
        .catch((err) => {
          this.error = true;
          this.disabled = false;
          this.rows = [];
        });
    },
    getProductivityReport(reqObj) {
      this.rows = null;
      this.error = false;
      this.months.length = 0;
      this.disabled = true;
      user
        .getProductivityReport(reqObj)
        .then((res) => {
          this.rows = res.data.data.data;
          this.months = res.data.data.headers;
          this.disabled = false;
        })
        .catch((err) => {
          this.error = true;
          this.disabled = false;
          this.rows = [];
        });
    },
    getApprovedHoursReport(reqObj) {
      this.rows = null;
      this.error = false;
      this.months.length = 0;
      this.disabled = true;
      user
        .getApprovedHoursReport(reqObj)
        .then((res) => {
          this.rows = res.data.data.data;
          this.months = res.data.data.headers;
          this.disabled = false;
        })
        .catch((err) => {
          this.error = true;
          this.disabled = false;
          this.rows = [];
        });
    },
    getUserOrganizationDropdown() {
      user.getListOrganization().then((result) => {
        this.organization_list = [
          { label: "Select all", user_organization: result.data.data },
        ];
      });
    },
    getUsers() {
      user.getUsers().then((result) => {
        this.master_user_list = [
          { label: "Select all", users_data: result.data.data },
        ];
        this.getFilteredUsers();
      });
    },
    getClients() {
      user.getclientDropdown().then((res) => {
        this.client_list = [
          { label: "Select all", clients_data: res.data.data },
        ];
      });
    },
    getFilteredUsers() {
      let [start_date, end_date] = this.reqObj.selected_range.value;
      let filtered_user_list = this.master_user_list[0].users_data.filter(
        (item) => {
          return (
            item.doe == null ||
            (item.doe != null && moment(item.doe).isSameOrAfter(start_date))
          );
        }
      );
      this.reqObj.users = this.reqObj.users.filter((item) => {
        // console.log(item.first_name, item.last_name, moment(item.doe));
        // return (
        //   item.doe == null ||
        //   (item.doe != null &&
        //     moment(item.doe).isBetween(start_date, end_date, null, "[]"))
        // );
        return (
          item.doe == null ||
          (item.doe != null && moment(item.doe).isSameOrAfter(start_date))
        );
      });
      this.user_list = structuredClone(this.master_user_list);
      this.user_list[0].users_data = filtered_user_list;
      // console.log(this.user_list);
    },
    applyFilters() {
      let reqObjCopy = structuredClone(this.reqObj);
      reqObjCopy.organizations = reqObjCopy.organizations.map(
        (item) => item.id
      );
      reqObjCopy.users = reqObjCopy.users.map((item) => item.id);
      reqObjCopy.selected_range = reqObjCopy.selected_range.value;
      reqObjCopy.clients = reqObjCopy.clients.map((item) => item.id);
      reqObjCopy.project_type = reqObjCopy.project_type?.value;
      if (this.page == "for_all_users") {
        this.getProductivityReport(reqObjCopy);
      }
      if (this.page == "for_tls") {
        this.getApprovedHoursReport(reqObjCopy);
      }
      if (this.page == "for_tls_team") {
        const { selected_range } = reqObjCopy;
        this.getTlTeamProductivityReport({
          selected_range,
          hierarchy_view: this.hierarch_view,
        });
      }
    },
    handleDefaultDateRangeSelection() {
      const start_date = moment()
        .subtract(1, "year")
        .set("month", 3)
        .startOf("month");
      const end_date = moment(start_date)
        .add(1, "year")
        .set("month", 2)
        .endOf("month");
      if (
        start_date.year() <= 2026 &&
        start_date.year() >= 2023 &&
        end_date.year() <= 2026 &&
        end_date.year() >= 2023
      ) {
        this.reqObj.selected_range = this.date_range_list.find(
          (item) =>
            item.value[0] == start_date.format("YYYY-MM-DD") &&
            item.value[1] == end_date.format("YYYY-MM-DD")
        );
      } else {
        this.reqObj.selected_range = this.date_range_list[0];
      }
    },
  },
  mounted() {
    this.getUsers();
    this.getClients();
    this.getUserOrganizationDropdown();
    this.handleDefaultDateRangeSelection();
    // this.reqObj.selected_range = this.date_range_list[1];
    this.reqObj.project_type = this.project_type_list[2];
    this.optionChanger("for_all_users");
  },
  created() {
    user.createSiteUsage(this.siteLogReq);
  },
  beforeMount() {
    this.permissions = localStorage.getItem("permissions");
  },
};
</script>

<style scoped>
.nav-link.active {
  color: #583d72;
  font-size: 14px !important;
  border-bottom: 2px solid #583d72;
  /* transition: 0.2s ease-in-out; */
}
.nav-link {
  font-size: 14px !important;
  color: #79869f;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  /* transition: 0.2s ease-in-out; */
}

.fa {
  font-size: 10px !important;
}

thead th {
  font-weight: 450 !important;
}

thead {
  font-size: 15px;
}

tbody {
  font-size: 14px;
}
/* .slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
} */
</style>
